import { stateTranslateKey } from "../constants/translate";
// import { Platform, PlatformActivityTypes, ResponseReaction } from "../types";

export interface FilterOptionData {
  value: any;
  label: string;
  icon?: string;
  stars?: number;
  labelAr?: string;
}

const states: string[] = [
  "Ariana",
  "Béja",
  "Ben Arous",
  "Bizerte",
  "Gabès",
  "Gafsa",
  "Jendouba",
  "Kairouan",
  "Kasserine",
  "Kebili",
  "Kef",
  "Mahdia",
  "Manouba",
  "Medenine",
  "Monastir",
  "Nabeul",
  "Sfax",
  "Sidi Bouzid",
  "Siliana",
  "Sousse",
  "Tataouine",
  "Tozeur",
  "Tunis",
  "Zaghouan",
];

export const StateOptions: FilterOptionData[] = states.map((state) => ({
  value: state,
  label: stateTranslateKey(state),
}));

export enum ResponseReaction {
  SLOW = "SLOW",
  MEDIUM = "MEDIUM",
  FAST = "FAST",
}

export enum PlatformActivityTypes {
  LOW = "LOW",
  MEDIUM = "MEDIUM",
  HIGH = "HIGH",
}

export enum Platform {
  FACEBOOK = "FACEBOOK",
  INSTAGRAM = "INSTAGRAM",
}

export const PlatformOptions: FilterOptionData[] = [
  {
    value: Platform.FACEBOOK,
    icon: "/images/facebook.svg",
    label: "platforms.facebook",
  },
  {
    value: Platform.INSTAGRAM,
    icon: "/images/instagram.svg",
    label: "platforms.instagram",
  },
];

export const LikesOptions: FilterOptionData[] = [
  { value: 1_000, label: "LikesNumbers.1k" },
  { value: 10_000, label: "LikesNumbers.10k" },
  { value: 100_000, label: "LikesNumbers.100k" },
];

export const ActivityOptions: FilterOptionData[] = [
  {
    value: [PlatformActivityTypes.MEDIUM, PlatformActivityTypes.HIGH],
    label: "activity.active",
  },
  {
    value: [PlatformActivityTypes.LOW],
    label: "activity.inactive",
  },
];

export const ReviewRateOptions: FilterOptionData[] = [
  {
    value: ["R_5"],
    label: "ratings.star_5",
    stars: 5,
  },
  {
    value: ["R_4", "R_4_5", "R_5"],
    label: "ratings.star_4",
    stars: 4,
  },
  {
    value: ["R_3", "R_3_5", "R_4", "R_4_5", "R_5"],
    label: "ratings.star_3",
    stars: 3,
  },
  {
    value: ["R_2", "R_2_5", "R_3", "R_3_5", "R_4", "R_4_5", "R_5"],
    label: "ratings.star_2",
    stars: 2,
  },
  {
    value: ["R_1", "R_1_5", "R_2", "R_2_5", "R_3", "R_3_5", "R_4", "R_4_5", "R_5"],
    label: "ratings.star_1",
    stars: 1,
  },
];

export const AnswerSpeedOptions: FilterOptionData[] = [
  {
    value: [ResponseReaction.MEDIUM, ResponseReaction.FAST],
    label: "answerSpeed.fast",
  },
  {
    value: [ResponseReaction.SLOW],
    label: "answerSpeed.slow",
  },
];

export const globalReviewOptions: FilterOptionData[] = [
  {
    value: [5],
    label: "globalRevueRatings.star_5",
    stars: 5,
  },
  {
    value: [4, 5],
    label: "globalRevueRatings.star_4",
    stars: 4,
  },
  {
    value: [3, 4, 5],
    label: "globalRevueRatings.star_3",
    stars: 3,
  },
  {
    value: [2, 3, 4, 5],
    label: "globalRevueRatings.star_2",
    stars: 2,
  },
  {
    value: [1, 2, 3, 4, 5],
    label: "globalRevueRatings.star_1",
    stars: 1,
  },
];
export const conformityImagesOptions: FilterOptionData[] = [
  {
    value: [5],
    label: "conformityImagesRating.star_5",
    stars: 5,
  },
  {
    value: [4, 5],
    label: "conformityImagesRating.star_4",
    stars: 4,
  },
  {
    value: [3, 4, 5],
    label: "conformityImagesRating.star_3",
    stars: 3,
  },
  {
    value: [2, 3, 4, 5],
    label: "conformityImagesRating.star_2",
    stars: 2,
  },
  {
    value: [1, 2, 3, 4, 5],
    label: "conformityImagesRating.star_1",
    stars: 1,
  },
];

export const clientServiceOptions: FilterOptionData[] = [
  {
    value: [5],
    label: "clientServiceRating.star_5",
    stars: 5,
  },
  {
    value: [4, 5],
    label: "clientServiceRating.star_4",
    stars: 4,
  },
  {
    value: [3, 4, 5],
    label: "clientServiceRating.star_3",
    stars: 3,
  },
  {
    value: [2, 3, 4, 5],
    label: "clientServiceRating.star_2",
    stars: 2,
  },
  {
    value: [1, 2, 3, 4, 5],
    label: "clientServiceRating.star_1",
    stars: 1,
  },
];
